// @flow

import { type Country } from '@tectonics/prs/country';
import { type PaymentSpec } from './types';

export function getCountry(spec: PaymentSpec): Country {
  return spec.country;
}
